import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';

export const Paragraph = styled(UI.Paragraph)``;

export const Section = styled(UI.Section)`
  display: flex;
  flex-direction: column;
  height: auto;
`;



// WEBPACK FOOTER //
// ./src/components/modules/About/styled.js